import React,{useEffect} from 'react';

const EmailLink=()=> (
  <a href="mailto:hello@ubeafoods.com" className="text-ube underline underline-offset-2 hover:text-ube-dark">
    hello@ubeafoods.com
  </a>
);

const PolicySection=({title,children})=> (
  <section className="mb-10">
    <h2 className="font-serif text-2xl text-ube-dark mb-4">{title}</h2>
    <div className="space-y-4 leading-8">{children}</div>
  </section>
);

const Bullet=({children})=> <li className="ml-5 list-disc pl-1">{children}</li>;

const Privacy=()=> {
  useEffect(()=> {
    const previousTitle=document.title;
    const description=document.querySelector('meta[name="description"]');
    const previousDescription=description?.getAttribute('content');
    document.title='Privacy Policy | UBEA';
    if (description) {
      description.setAttribute('content','How UBEA by Stonecord LLC collects, uses, and protects your information.');
    }
    return ()=> {
      document.title=previousTitle;
      if (description && previousDescription) description.setAttribute('content',previousDescription);
    };
  },[]);

  return (
    <main className="bg-sand-light min-h-screen py-16 md:py-24">
      <article className="max-w-[720px] mx-auto px-5 sm:px-8 text-gray-900 leading-8">
        <h1 className="font-serif text-4xl md:text-5xl text-ube-dark leading-tight mb-4">Privacy Policy</h1>
        <p className="mb-8">Effective date: October 2, 2026</p>
        <p className="mb-10">
          This Privacy Policy explains how Stonecord LLC, doing business as UBEA ("UBEA," "we," "us"), collects, uses, and shares information when you visit ubeafoods.com or any related site (the "Site"), place an order, or contact us.
        </p>

        <PolicySection title="1. Information we collect">
          <p>Information you give us:</p>
          <ul className="space-y-2">
            <Bullet>Contact details — name, email, phone, and company (for wholesale inquiries) when you use our contact or wholesale forms or email us.</Bullet>
            <Bullet>Order details — name, shipping and billing address, email, phone, and the products you buy.</Bullet>
            <Bullet>Payment information — card details are entered with and processed by our payment processor, [PAYMENT PROCESSOR]. We do not store full card numbers.</Bullet>
            <Bullet>Anything else you choose to send us, such as messages, reviews, or photos.</Bullet>
          </ul>
          <p>Information collected automatically:</p>
          <ul className="space-y-2">
            <Bullet>Device and usage data such as IP address, browser type, pages viewed, and referring site, collected by our hosting provider and site tools for security and to keep the Site working.</Bullet>
            <Bullet>Your cart contents may be saved in your browser so they're there when you return.</Bullet>
          </ul>
        </PolicySection>

        <PolicySection title="2. How we use your information">
          <ul className="space-y-2">
            <Bullet>To process, ship, and support your orders, including subscription orders.</Bullet>
            <Bullet>To answer your questions and wholesale inquiries.</Bullet>
            <Bullet>To send order confirmations, shipping updates, and other service messages.</Bullet>
            <Bullet>To send marketing emails, only if you've opted in. You can unsubscribe at any time using the link in any email.</Bullet>
            <Bullet>To protect against fraud and keep the Site secure.</Bullet>
            <Bullet>To comply with legal, tax, and accounting obligations.</Bullet>
          </ul>
        </PolicySection>

        <PolicySection title="3. How we share your information">
          <p>We do not sell your personal information, and we do not share it for cross-context behavioral advertising. We share it only with:</p>
          <ul className="space-y-2">
            <Bullet>Service providers who help us run the business — website hosting (Netlify), payment processing ([PAYMENT PROCESSOR]), shipping carriers, and email delivery ([EMAIL PLATFORM]). They may use your information only to provide services to us.</Bullet>
            <Bullet>Authorities, when required by law or to protect our rights, customers, or others.</Bullet>
            <Bullet>A buyer or successor, if our business is sold or reorganized.</Bullet>
          </ul>
        </PolicySection>

        <PolicySection title="4. Cookies and similar technologies">
          <p>We use browser storage and cookies needed for the Site to function, such as remembering your cart. You can clear or block these in your browser settings, but parts of the Site may not work properly.</p>
        </PolicySection>

        <PolicySection title="5. Do Not Track">
          <p>Our Site does not currently respond to browser "Do Not Track" signals. We do not track you across third-party websites.</p>
        </PolicySection>

        <PolicySection title="6. How long we keep information">
          <p>We keep order records as long as needed for tax and accounting purposes, and other information only as long as needed for the purposes above.</p>
        </PolicySection>

        <PolicySection title="7. Security">
          <p>We use reasonable safeguards to protect your information. No method of transmission or storage is completely secure, so we cannot guarantee absolute security.</p>
        </PolicySection>

        <PolicySection title="8. Your choices and rights">
          <ul className="space-y-2">
            <Bullet>You can ask to see, correct, or delete the personal information we hold about you by emailing <EmailLink />. We'll respond within a reasonable time and may need to verify your identity.</Bullet>
            <Bullet>You can opt out of marketing emails at any time with the unsubscribe link.</Bullet>
            <Bullet>California residents: under California's "Shine the Light" law, you may request information about any personal information we have shared with third parties for their direct marketing purposes. We do not share personal information for that purpose.</Bullet>
          </ul>
        </PolicySection>

        <PolicySection title="9. Children's privacy">
          <p>The Site is not directed to children under 13, and we do not knowingly collect personal information from them. If you believe a child has given us information, contact us and we will delete it.</p>
        </PolicySection>

        <PolicySection title="10. Changes to this policy">
          <p>We may update this policy from time to time. We'll post the updated version on this page and change the effective date above. Significant changes will be highlighted on the Site.</p>
        </PolicySection>

        <PolicySection title="11. Contact us">
          <p>UBEA by Stonecord LLC<br />Mailing Address: 18047 Beach Blvd #1802, Huntington Beach, CA 92648<br />Email: <EmailLink /></p>
        </PolicySection>
      </article>
    </main>
  );
};

export default Privacy;